
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"tapered_baguette"}},[_c('polygon',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","points":"32.88 44 15.12 44 11.52 4 36.48 4 32.88 44"}}),_c('polygon',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","points":"31.43 42.4 16.56 42.4 13.26 5.6 34.74 5.6 31.43 42.4"}}),_c('polygon',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","points":"28.94 39.68 19.02 39.68 16.23 8.32 31.77 8.32 28.94 39.68"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"11.52","y1":"4","x2":"16.23","y2":"8.32"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"36.48","y1":"4","x2":"31.77","y2":"8.32"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"15.12","y1":"44","x2":"19.02","y2":"39.68"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"32.88","y1":"44","x2":"28.94","y2":"39.68"}})])])
          )
        }
      }
    